import React from "react";
import styles from "./index.module.scss";
import {
  getDateFromString,
  getDayOfWeek,
  getMonthAbbreviation,
  getYearBasedOnDate,
} from "../../utils/commonFunctions";
import locationIcon from "../../assets/images/location-icon.svg";
import CalendarTodayIcon from "../../assets/images/calendar.svg";
import clockIcon from "../../assets/images/clock.svg";
import Line from "../../assets/images/line.svg";
import { calculateDaysLeft } from "../../utils/commonFunctions";
import Duration from "../../assets/images/time-duration-symbol.svg";

interface RectangularCardProps {
  title?: string;
  venue?: string;
  startDate?: string;
  endDate?: string;
  payment?: {
    amount: string;
    currency: string;
  };
  hdbFee?: string
  msdFee?: string
  registrationStartDate?: string;
}
const setDuration = (startDate: string, endDate: string): number => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const duration = Math.ceil((end.getTime() - start.getTime()) / (1000 * 3600 * 24));
  return duration;
}
const formatINR = (amount: string | number) => {
  const num = Number(amount);
  if (isNaN(num)) return amount;
  return num.toLocaleString("en-IN", { style: "decimal", maximumFractionDigits: 2 });
};
const RectangularCard: React.FC<RectangularCardProps> = ({
  title = "Program Title",
  venue = "Venue",
  startDate,
  endDate,
  payment,
  hdbFee,
  msdFee,
}) => {
  return (
    <div className={styles.rectangularCardContainer}>
      <div className={styles.cardContent}>
        {/* Title */}
        <h2 className={styles.title}>{title}</h2>

        {/* Venue */}
        <div className={styles.infoRow}>
          <img src={locationIcon} alt="Location Icon" className={styles.icon} />
          <span className={styles.text}>{venue}</span>
        </div>

        {/* Date Range */}
        <div className={styles.infoRow}>
          <img
            src={CalendarTodayIcon}
            alt="Calendar Icon"
            className={styles.icon}
          />
          <div className={styles.dateRange}>
            {startDate && endDate && (
              <span>
                {getDateFromString(startDate)}-
                {getMonthAbbreviation(startDate)}-
                {getYearBasedOnDate(startDate)} <span className={styles.dateSeparator}> To </span>
                {getDateFromString(endDate)}-
                {getMonthAbbreviation(endDate)}-
                {getYearBasedOnDate(endDate)}
              </span>
            )}
          </div>
        </div>
        <div className={styles.infoRow}>
          <img src={Duration} alt="Duration Icon" className={styles.icon} />
          <span className={styles.text}>
            {startDate && endDate && (
              <span>
                {setDuration(startDate, endDate)} days
              </span>
            )}
          </span>
        </div>

        <img src={Line} alt="line" className={styles.line} />

        {/* Payment */}
        {payment && (!title.includes("HDB") || !title.includes("MSD")) && (
          <div className={styles.infoRowGap}>
            <span className={styles.paymentText}>Total Payable</span>
            <span className={styles.payment}>
              {payment.currency} {formatINR(payment.amount)}
            </span>
          </div>
        )}
        {
          hdbFee && title.includes("HDB") && (
            <div className={styles.infoRowGap}>
              <span className={styles.paymentText}>HDB Fee</span>
              <span className={styles.payment}>
                &#8377; {formatINR(hdbFee)}
              </span>
            </div>
          )
        }
        {
          msdFee && title.includes("MSD") && (
            <div className={styles.infoRowGap}>
              <span className={styles.paymentText}>MSD Fee</span>
              <span className={styles.payment}>
                &#8377; {formatINR(msdFee)}
              </span>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default RectangularCard;
